<template>
  <div class="activity-item">
    <div class="activity-date">
      <div class="date-day">{{ activity.formatDate.day }}</div>
      <div class="date-month">{{ activity.formatDate.month }}</div>
    </div>
    <div class="activity-title">{{ activity.title }}</div>
  </div>
</template>

<script>
export default {
  name: 'ActivityItem',
  props: {
    activity: {
      type: Object,
      required: true,
      default: () => ({})
    }
  }
}
</script>

<style scoped>
.activity-item {
  display: flex;
  align-items: flex-start;
  padding: 10px 14px;
  cursor: pointer;
}

.activity-item:hover {
  background-color: #f5f7fa;
}

.activity-date {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 40px;
  margin-right: 10px;
}

.date-day {
  font-size: 20px;
  font-weight: 600;
  color: #606266;
}

.date-month {
  font-size: 12px;
  color: #909399;
}

.activity-title {
  flex: 1;
  font-size: 14px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>